<template>
  <div class="acls-training-page">
    <header class="hero-section">
      <h1>ACLS Training</h1>
      <p>ACLS training to enhance cardiologists' expertise in emergency cardiac care.</p>
    </header>

    <main class="main-content">
      <section class="content-section">
        <div class="section-header-tabs">
          <h2 class="active">Jadwal Pelatihan</h2>
        </div>
        <div class="section-body">
          <h3>Pendaftaran Pelatihan ACLS PERKI</h3>
          <p>
            Sekretariat PERKI (Pusat): Telepon 021-568-4093, 021-568-1149 (hunting) 0812-9799-2400 |
            Hanni 0818-1058-5241 | Gedung Perki House, Jl. Danau Sunter Barat Blok A3 No.1-2, Sunter
            Agung, Jakarta Utara 14350.
          </p>
        </div>
      </section>

      <section class="content-section">
        <div class="section-header-tabs">
          <h2 class="active">Syarat dan Peserta</h2>
        </div>
        <div class="section-body">
          <h3>Persyaratan Peserta</h3>
          <ul class="styled-list">
            <li>Peserta adalah Dokter Umum, Dokter Spesialis, dan Dokter Subspesialis.</li>
            <li>Surat Tanda Registrasi (STR) yang masih berlaku.</li>
            <li>Pendaftaran dinyatakan diterima bila panitia telah menerima bukti pembayaran.</li>
            <li>
              Semua peserta diwajibkan untuk swab antigen/PCR dengan hasil negatif (non-reaktif)
              maksimal 1x24 jam sebelum pelatihan dimulai (1 hari sebelum pelatihan) dibuktikan
              dengan...
            </li>
            <li>
              Penyelenggara akan menerapkan protokol kesehatan yang ada pada saat pelatihan,
              penyelenggara tidak akan bertanggung jawab terhadap penularan bila terjadi...
            </li>
            <li>Peserta tidak diperkenankan membawa dan menggunakan APD (Hazmat) dari luar.</li>
            <li>Wajib memakai sarung tangan saat praktek dan ujian.</li>
            <li>Peserta tidak diperkenankan mendokumentasikan pelatihan (foto, video, dII).</li>
            <li>
              Peserta diwajibkan mengikuti seluruh rangkaian acara pelatihan dari awal hingga akhir,
              ketidakhadiran di salah satu sesi akan...
            </li>
            <li>Membawa peralatan ibadah masing-masing.</li>
            <li>Membawa obat-obatan pribadi masing-masing.</li>
            <li>Bagi peserta dengan kondisi hamil...</li>
          </ul>
        </div>
      </section>

      <section class="content-section">
        <div class="section-header-tabs scrollable">
          <h2 class="active">Jadwal Acara</h2>
        </div>
        <div class="section-body">
          <h3>Rundown Peserta Latihan</h3>

          <div class="rundown-image-wrapper">
            <img :src="rundownImage" alt="Rundown Peserta Latihan ACLS" class="rundown-image" />
          </div>

          <div class="info-box-gray">
            <ul>
              <li>
                Hari pertama pelatihan akan dilakukan secara daring (online) melalui aplikasi ZOOM.
              </li>
              <li>Peserta wajib mendownload aplikasi ZOOM.</li>
              <li>
                Link ZOOM meeting akan dibagikan ke peserta minimal 1 hari sebelum pelatihan
                dimulai.
              </li>
              <li>
                Hari kedua dan ketiga peserta WAJIB datang ke tempat pelatihan di (Gedung PERKI
                House).
              </li>
              <li>Wajib menonton video kuliah dan video simulasi skill.</li>
              <li>
                1 Minggu sebelum pelatihan panitia akan menghubungi dan membuat grup whastapp.
              </li>
            </ul>
          </div>

          <div class="keterangan-tabel">
            <strong>Keterangan Jadwal Acara:</strong>
            <ul>
              <li>Jadwal Acara dapat berubah sewaktu-waktu, akan diinformasikan segera.</li>
              <li>Peserta wajib memberikan nomer HP yang aktif (WhatsApp).</li>
              <li>
                Peserta wajib bergabung ke dalam grup WhatsApp yang akan dibuat oleh panitia, untuk
                mempermudah komunikasi.
              </li>
              <li>
                Diharapkan peserta dapat berkonsentrasi penuh selama pelatihan ACLS, pastikan tidak
                ada gangguan selama pelatihan, karena akan mempengaruhi...
              </li>
              <li>
                ...kelulusan peserta pelatihan ACLS demi kelancaran dan menjaga anak Shosapp...
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section class="content-section">
        <div class="section-header-tabs">
          <h2 class="active">Materi Pelatihan</h2>
        </div>
        <div class="section-body">
          <h3>Materi Pelatihan</h3>
          <ul class="styled-list">
            <li>Basic Life Support dan High Quality CPR</li>
            <li>
              Tatalaksana Henti Jantung: Ventricular Fibrillation/Pulseless Ventricular Tachycardia
            </li>
            <li>Tatalaksana Henti Jantung: Asystole dan PEA</li>
            <li>Bradikardia</li>
            <li>Takikardia</li>
            <li>Acute Coronary Syndrome</li>
            <li>Acute Heart Failure</li>
            <li>Manajemen Jalan Napas</li>
            <li>Bantuan Hidup Lanjut Pediatrik</li>
            <li>Bantuan Hidup Lanjut Neonatus</li>
            <li>Etika Medikolegal</li>
            <li>Komunikasi dalam Kegawatan Kardiovaskular dengan Berbagai Varian Kasus</li>
            <li>Echocardiography</li>
            <li>Bantuan Hidup Lanjut</li>
          </ul>
        </div>
      </section>

      <section class="content-section">
        <div class="section-body">
          <h3>Tim Pengajar</h3>
          <p>
            Pelatihan ACLS PERKI didukung oleh tim pengajar yang terdiri dari Dokter Spesialis
            Jantung dan Pembuluh Darah, Dokter Spesialis Anestesi dan Dokter Spesialis lainnya yang
            kompeten.
          </p>
        </div>
      </section>

      <section class="content-section">
        <div class="section-body">
          <h3>Kelulusan</h3>
          <p>
            Peserta yang dapat lulus pelatihan dan mendapatkan sertifikat adalah peserta dengan
            kompetensi dengan dengan hanya membayar biaya konsumsi.
          </p>
        </div>
      </section>

      <section class="content-section">
        <div class="section-body">
          <h3>Jadwal & Lokasi</h3>
          <p>
            🗓️ Kegiatan diadakan 2 kali 3 hari pada Hari Ke-1 (Online) dan Hari Ke-2 & 3 (Offline)
            Gedung PERKI House | <strong>Jumat - Sabtu</strong>
          </p>
          <p>
            📍 Gedung Perki House, Jl. Danau Sunter Barat Blok A3 No. 1-2, Sunter Agung, Jakarta
            Utara 14350 |
            <a href="https://maps.app.goo.gl/rMxAUv76kvnAyjSA8" target="_blank"
              >https://maps.app.goo.gl/rMxAUv76kvnAyjSA8</a
            >
          </p>
        </div>
      </section>

      <section class="content-section">
        <div class="section-body">
          <h3>Fasilitas Pelatihan</h3>
          <ul class="styled-list">
            <li>Buku Panduan</li>
            <li>Pocket Mask</li>
            <li>Sertifikat</li>
            <li>Makan Siang & Coffee Break</li>
          </ul>
        </div>
      </section>

      <section class="content-section">
        <div class="section-body">
          <h3>Pembayaran Pelatihan ACLS</h3>
          <p>
            Pembayaran Pelatihan ACLS PERKI ditransfer ke rekening:
            <strong>PERKI Cq. Pusat</strong> | Bank Mandiri - Cabang RSCM |
            <strong>No. Rek: 122.00.0762.333.3</strong>
          </p>
          <p>Biaya Pelatihan <strong>Rp. 3.500.000,- (Tiga Juta Lima Ratus Ribu Rupiah)</strong></p>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
// --- PENTING ---
// Ganti path ini dengan path gambar RUNDOWN BARU yang Anda kirim
// (image_66497f.png)
import rundownImage from '@/assets/img/courses/tabel-acls.png'

export default {
  name: 'ACLSTraining',
  data() {
    return {
      rundownImage, // Daftarkan gambar di sini
    }
  },
}
</script>

<style scoped>
.acls-training-page {
  font-family: 'Arial', sans-serif;
  color: #333;
  background-color: #fff;
}

/* Breadcrumb */
.breadcrumb {
  padding: 1rem 5%;
  background-color: #f8f9fa;
  font-size: 0.9rem;
  color: #666;
}

/* Hero Section */
.hero-section {
  text-align: center;
  padding: 3rem 1rem;
  background-color: #fff;
}

.hero-section h1 {
  font-size: 2.5rem;
  font-weight: 700;
  color: #000;
  margin-bottom: 0.5rem;
}

.hero-section p {
  font-size: 1.1rem;
  color: #555;
  max-width: 600px;
  margin: 0 auto;
}

/* Main Content */
.main-content {
  max-width: 1100px;
  margin: 0 auto;
  padding: 2rem 1rem;
}

.content-section {
  margin-bottom: 3rem;
}

/* Styling "Tabs" Palsu */
.section-header-tabs {
  display: flex;
  align-items: center;
  border-bottom: 2px solid #eee;
  padding-bottom: 0.5rem;
  margin-bottom: 1.5rem;
  gap: 1.5rem;
}

.section-header-tabs h2.active {
  font-size: 1.25rem;
  font-weight: 700;
  color: #e10f28; /* Merah PERKI */
  margin: 0;
  padding-bottom: 0.5rem;
  border-bottom: 3px solid #e10f28;
  white-space: nowrap; /* Mencegah judul terputus */
}

.section-header-tabs span {
  font-size: 1.25rem;
  font-weight: 600;
  color: #aaa; /* Abu-abu */
  margin: 0;
  white-space: nowrap;
}

.section-header-tabs.scrollable {
  overflow-x: auto;
  padding-bottom: 1rem; /* Beri ruang untuk scrollbar */
}

.section-body {
  padding-left: 0.5rem;
}

.section-body h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #000;
  margin-bottom: 1rem;
}

.section-body p {
  font-size: 1rem;
  line-height: 1.6;
  color: #555;
}

/* Menggunakan .styled-list untuk semua daftar UL */
.styled-list {
  list-style-type: disc;
  padding-left: 20px;
}

.styled-list li {
  font-size: 1rem;
  line-height: 1.6;
  color: #555;
  margin-bottom: 0.75rem;
}

/* --- PERUBAHAN CSS --- */

/* Wrapper untuk gambar rundown */
.rundown-image-wrapper {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
  overflow: hidden;
  border-radius: 8px;
  border: 1px solid #ddd;
}

.rundown-image {
  width: 100%;
  height: auto;
  display: block;
}

/* Kotak info abu-abu (HTML) */
.info-box-gray {
  background-color: #f8f9fa;
  padding: 1.5rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
}

.info-box-gray ul {
  margin: 0;
  padding-left: 20px;
  list-style-type: disc;
}

.info-box-gray li {
  font-size: 0.95rem;
  color: #333;
  margin-bottom: 0.5rem;
  line-height: 1.6;
}

/* Keterangan Tabel (HTML) */
.keterangan-tabel {
  margin-top: 1.5rem;
  font-size: 0.9rem;
}

.keterangan-tabel strong {
  font-size: 1rem;
  display: block;
  margin-bottom: 0.5rem;
}

.keterangan-tabel ul {
  list-style: none;
  padding: 0;
}

.keterangan-tabel li {
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
  color: #666;
}

/* Link */
a {
  color: #e10f28;
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}

/* Responsive */
@media (max-width: 768px) {
  .hero-section h1 {
    font-size: 2rem;
  }
  .main-content {
    padding: 1rem;
  }
  .section-header-tabs {
    gap: 1rem;
  }
  .section-header-tabs h2.active,
  .section-header-tabs span {
    font-size: 1.1rem;
  }
}
</style>
